if (!customElements.get('selling-plan')) {
  class SellingPlan extends HTMLElement {
    selectors = {
      sellingPlanInput: '[name="selling_plan"]',
      purchaseOption: '[name="purchase_option"]',
      subscribeOptionContainer: '[selling-plan="subscribe-option-container"]',
      subscribeSelect: '[name="selling_plan_select"]',
      subscribeRadio: '[name="selling-plan-subscribe-radio"]',
      selectedSubscribeInput:
        '[selling-plan="subscribe-option-container"] [name="selling_plan_select"], [selling-plan="subscribe-option-container"] [name="selling-plan-subscribe-radio"]:checked',
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.sellingPlanInput = this.querySelector(
        this.selectors.sellingPlanInput,
      );
      this.addEventListener('change', this.handleOptionChange.bind(this));
    }

    /**
     * Handle option change.
     *
     * @returns {Void}
     */
    handleOptionChange() {
      this.purchaseOption = this.querySelector(
        `${this.selectors.purchaseOption}:checked`,
      );

      if (this.purchaseOption.hasAttribute('value')) {
        this.updateSellingPlan(this.purchaseOption);

        return;
      }

      if (
        this.purchaseOption.closest(this.selectors.subscribeOptionContainer)
      ) {
        const option = this.querySelector(
          this.selectors.selectedSubscribeInput,
        );

        this.updateSellingPlan(option);
      }
    }

    /**
     * Update selling plan.
     *
     * @param {HTMLElement} option Selected selling plan option
     * @returns {Void}
     */
    updateSellingPlan(option) {
      if (!option) {
        return;
      }

      this.sellingPlanInput.value = option.value;

      window.dispatchEvent(new CustomEvent('selling-plan-change'), {
        bubbles: true,
      });
    }
  }
  customElements.define('selling-plan', SellingPlan);
}
